import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

import Tab from './Tabs';
import Toggler from '../../../components/UI/Toggler';
import makeUrl from '../../../lib/makeUrl';

type State = { dropdownOpen: boolean };
type Props = {
  prefix: string,
  active: boolean,
  numberOfDays: number,
  name: string,
  id: string,
  region: string,
};

export default class DayTabsMobile extends Component<Props, State> {
  render() {
    const { prefix, active, name, id, region } = this.props;
    const trekOverviewUrl = id ? makeUrl.trekOverview(name, id, region) : prefix;

    return (
      <Toggler>
        {({ on, toggle }) => (
          <div className="col-12 mobile-dp">
            <Dropdown isOpen={on} toggle={toggle}>
              <DropdownToggle caret>{active ? `Day ${active}` : 'Overview'}</DropdownToggle>
              <DropdownMenu className="days-tabs">
                <Tab text="Overview" url={trekOverviewUrl} active={!active} />
                {this.renderDayTabs(toggle)}
              </DropdownMenu>
            </Dropdown>
          </div>
        )}
      </Toggler>
    );
  }

  renderDayTabs = toggle => {
    const { numberOfDays, active, name, id, region } = this.props;

    return new Array(numberOfDays).fill(null).map((n, idx) => {
      const day = `${idx + 1}`;
      const dayUrl = makeUrl.goToDay(name, id, Number(day), region);

      return (
        <Tab
          key={day}
          text={`Day ${day}`}
          url={dayUrl}
          active={active === day}
          dropdownToggle={toggle}
        />
      );
    });
  };
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DayTabs/DayTabsMobile.js